export default {
  paper: {
    top: 'var(--dpoday-banner-height, 0px)',
    height: 'calc(100% - var(--dpoday-banner-height, 0px))',
  },
}
